<template>
<div id="">
  <v-dialog v-model="show_video_player" max-width="1024">
    <v-card>

      <div class="video-responsive" v-if="show_video_player && videoType==='iframe'">
        <iframe @load="loadedFrame" :src="videoId" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" autoplay allowfullscreen></iframe>
      </div>
      <div class="video-responsive" v-if="show_video_player && videoType==='video'">
        <video controls autoplay>
      <source :src="video_url" type="video/mp4">
      <source :src="video_url" type="video/ogg">
      Your browser does not support HTML5 video.
        </video>
      </div>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
export default {
  name: "",
  created() {
    this.$eventBus.$on('play_video', this.playVideo)
  },
  data: () => ({
    video_url: '',
    show_video_player: false,
    frameloaded: false
  }),
  methods: {
    playVideo: function(url) {
      this.frameloaded = false;
      this.video_url = url;
      this.show_video_player = true;
    },
    loadedFrame: function() {
      this.frameloaded = true
    }
  },
  computed: {
    videoType: function() {
      if (!this.video_url) {
        return null
      }
      if (this.video_url.includes('youtube') || this.video_url.includes('vimeo')) {
        return 'iframe'
      }
      return 'video'
    },
    videoId: function() {
      if (!this.video_url) {
        return ''
      }
      return `${this.$helpers.iframeFromUrl(this.video_url)}?autoplay=1`
    }
  }
}
</script>


<style lang="scss" scoped>
.video-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
    background: #424242;
}
.video-responsive iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
}
.video-responsive video {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
}
</style>
